import { PENDING_UPLOADS } from '../constants'
import { PendingUpload } from './addPendingUpload'

export function savePendingUploads(uploads: PendingUpload[]) {
  localStorage.setItem(PENDING_UPLOADS, JSON.stringify(uploads))
}
